(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ui/mobile-input/assets/javascripts/components/mobile-input.trinidad.js') >= 0) return;  svs.modules.push('/components/ui/mobile-input/assets/javascripts/components/mobile-input.trinidad.js');
"use strict";

(() => {
  "use strict";

  var __webpack_require__ = {};
  (() => {
__webpack_require__.n = module => {
var getter = module && module.__esModule ? () => module['default'] : () => module;
      __webpack_require__.d(getter, {
        a: getter
      });
      return getter;
    };
  })();
  (() => {
__webpack_require__.d = (exports, definition) => {
for (var key in definition) {
if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
Object.defineProperty(exports, key, {
            enumerable: true,
            get: definition[key]
          });
        }
      }
    };
  })();
  (() => {
__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);
  })();
  var __webpack_exports__ = {};

  __webpack_require__.d(__webpack_exports__, {
    "default": () => (mobile_input)
  });
  ; 
  const external_PropTypes_namespaceObject = window["PropTypes"];
  var external_PropTypes_default = __webpack_require__.n(external_PropTypes_namespaceObject);
  ; 
  const external_svs_ui_ReactForm_namespaceObject = window["svs"]["ui"]["ReactForm"];
  ; 
  const _excluded = ["errorMessageDefault", "errorMessageRequired", "helpMessage", "infoMessage", "isRequired", "label", "name", "isLessSpace", "onBlur", "onChange", "onFocus", "value"];
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  const MobileInput = _ref => {
    let errorMessageDefault = _ref.errorMessageDefault,
      errorMessageRequired = _ref.errorMessageRequired,
      helpMessage = _ref.helpMessage,
      infoMessage = _ref.infoMessage,
      isRequired = _ref.isRequired,
      label = _ref.label,
      name = _ref.name,
      isLessSpace = _ref.isLessSpace,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    const validatePhoneNumber = phoneNumber => {
      const phoneNumberRegExp = /^(07\d{8}|(00|\+)?46\d{9})$/;
      phoneNumber = phoneNumber.replace(/-|\s/g, '');
      return phoneNumberRegExp.test(phoneNumber);
    };
    const validate = (event, value) => {
      const isValidPhoneNumber = validatePhoneNumber(value);
      const hasValue = value.length > 0;
      let isValid = hasValue && isValidPhoneNumber;
      let currentErrorMessage = '';
      if (event === 'onSubmit' && isRequired && !hasValue) {
        currentErrorMessage = errorMessageRequired;
      } else if (!isValidPhoneNumber) {
        currentErrorMessage = errorMessageDefault;
      }
      if (event === 'onBlur' || !isRequired) {
        isValid = isValidPhoneNumber;
        if (value === '') {
          isValid = true;
          currentErrorMessage = '';
        }
      }
      return {
        errorMessage: currentErrorMessage,
        isValid,
        name
      };
    };
    return React.createElement(external_svs_ui_ReactForm_namespaceObject.FormContext.Consumer, null, _ref2 => {
      let form = _ref2.form,
        handleBlur = _ref2.handleBlur,
        handleChange = _ref2.handleChange,
        handleFocus = _ref2.handleFocus,
        register = _ref2.register;
      return React.createElement(external_svs_ui_ReactForm_namespaceObject.ControlGroup, {
        errorMessage: form[name] && form[name].errorMessage,
        hasError: form[name] && !form[name].isValid,
        infoMessage: infoMessage,
        isLessSpace: isLessSpace,
        v2: true
      }, React.createElement(external_svs_ui_ReactForm_namespaceObject.Inputv2, _extends({
        autoCapitalize: "off",
        autoComplete: "tel",
        autoCorrect: "off",
        inputHelpText: helpMessage,
        label: label,
        name: name,
        onBlur: e => {
          handleBlur(e, onBlur);
        },
        onChange: e => {
          handleChange(e, onChange);
        },
        onFocus: e => {
          handleFocus(e, onFocus);
        },
        refElem: register(name, validate),
        spellCheck: "false",
        type: "tel",
        value: value
      }, props)));
    });
  };
  MobileInput.defaultProps = {
    errorMessageDefault: 'Ogiltigt format på mobilnumret',
    errorMessageRequired: 'Du måste ange ett mobilnummer',
    isRequired: true,
    label: 'Ange mobilnummer'
  };
  MobileInput.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "MobileInput",
    "props": {
      "errorMessageDefault": {
        "defaultValue": {
          "value": "'Ogiltigt format p\xE5 mobilnumret'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "errorMessageRequired": {
        "defaultValue": {
          "value": "'Du m\xE5ste ange ett mobilnummer'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isRequired": {
        "defaultValue": {
          "value": "true",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "label": {
        "defaultValue": {
          "value": "'Ange mobilnummer'",
          "computed": false
        },
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "helpMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "infoMessage": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": false
      },
      "isLessSpace": {
        "description": "",
        "type": {
          "name": "bool"
        },
        "required": false
      },
      "name": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      },
      "onBlur": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "onChange": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": true
      },
      "onFocus": {
        "description": "",
        "type": {
          "name": "func"
        },
        "required": false
      },
      "value": {
        "description": "",
        "type": {
          "name": "string"
        },
        "required": true
      }
    }
  };
  const mobile_input = MobileInput;
  (((window.svs = window.svs || {}).ui = window.svs.ui || {}).ReactFormInputs = window.svs.ui.ReactFormInputs || {}).MobileInput = __webpack_exports__["default"];
})();

 })(window);